export default __webpack_public_path__ + "static/media/langchainIcon.7d5c1a8c.svg";